import React, { useCallback, useEffect } from 'react';
import PubSub from 'pubsub-js';
import { COMMON_ERROR_ALERT_CHANGE_EVENT } from '../../api';
import _ from 'lodash';
import { customToast } from '../../utils';
import { useTranslation } from 'react-i18next';

export const CommonErrorAlert: React.FC = () => {
  const { t } = useTranslation();

  const errorSubscriber = useCallback(
    (_msg: string, errorMessages: string[]) => {
      const errorMessagesString = _.join(errorMessages, ', ');
      customToast(
        {
          title: t('common.something_is_wrong'),
          subtitle: errorMessagesString,
        },
        'error',
      );
    },
    [t],
  );

  useEffect(() => {
    const subscriberToken = PubSub.subscribe(
      COMMON_ERROR_ALERT_CHANGE_EVENT,
      errorSubscriber,
    );

    return () => {
      PubSub.unsubscribe(subscriberToken);
    };
  }, [errorSubscriber]);

  return null;
};
